import { render } from "./OdontologyPanel.vue?vue&type=template&id=2bf9c7de"
import script from "./OdontologyPanel.vue?vue&type=script&lang=js"
export * from "./OdontologyPanel.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__